<template>
  <div class="hello">
    <HomeImg></HomeImg>
    <introduction></introduction>
    <cpjs></cpjs>

    <jjfa></jjfa>
    <llyy></llyy>
    <gsxw></gsxw>

  </div>
</template>

<script>
import HomeImg from './image/image'
import Introduction from "./image/introduction";
import Cpjs from "./image/cpjs";
import Gsxw from "./image/gsxw";
import Jjfa from "./image/jjfa";
import Llyy from "./image/llyy";

export default {

  name: 'HelloWorld',
  components: {
    Llyy,
    Jjfa,
    Gsxw,
    Cpjs,
    Introduction,
    HomeImg
  },
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello{
  background: #FFFFFF;
  width: 1920px;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/en/HelloWorld.vue